import ResearchClient, { ErrorResearchClient } from 'requests/objects/researchClient'
import ApiHandler from 'requests/apiHandler'

/**
 * ResearchClientsHandler
 * @augments {ApiHandler<ResearchClient, ErrorResearchClient>}
 */
export default class ResearchClientsHandler extends ApiHandler {
    constructor() {
        super({ type: ResearchClient, errorType: ErrorResearchClient, key: 'research-clients' })
    }
}
